import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';


class BsyDashboardRecentUseConfig extends React.Component {
constructor(props) {
    super(props);

    this.state = {
    };
}

    render() {
        return <div>123</div>;
    }
}



export default BsyDashboardRecentUseConfig;